module.exports = __webpack_public_path__ + "media/stylesheets/images/cancel-2c9114915b41239ff0c36972d2674341.svg";